// Shared BP action definitions for the Action overlay used across reports and search.
// - path(bn): open legacy PHP page in an iframe overlay
// - post: submit a hidden form into the iframe (Payment Reversal)
// - reactPath(bn): navigate to a React route (Bill Payment)

export const BP_ACTION_ITEMS = [
  {
    key: 'bill-payment',
    label: 'Bill Payment',
    icon: 'mdi-cash-multiple',
    reactPath: (bn) => `/crm/receive-payments?bn=${encodeURIComponent(bn || '')}`,
  },
  {
    key: 'ledger',
    label: 'BP Individual Ledger',
    icon: 'mdi-book-open-page-variant',
    path: (bn) => `/reports/passbook.php?business_partner_id=${bn}`,
  },
  {
    key: 'change-status',
    label: 'BP Change Status',
    icon: 'mdi-toggle-switch',
    path: (bn) => `/action/change_status.php?bn=${bn}`,
  },
  {
    key: 'change-scheme',
    label: 'BP Change Scheme',
    icon: 'mdi-file-tree',
    path: (bn) => `/action/change_scheme.php?bn=${bn}`,
  },
  {
    key: 'change-outstanding',
    label: 'BP Change Outstanding',
    icon: 'mdi-currency-inr',
    path: (bn) => `/action/change_outstand.php?bn=${bn}`,
  },
  {
    key: 'change-meter',
    label: 'BP Change Meter',
    icon: 'mdi-gauge',
    path: (bn) => `/action/change_meter.php?bn=${bn}`,
  },
  {
    key: 'payment-reversal',
    label: 'Payment Reversal',
    icon: 'mdi-backup-restore',
    post: true,
    action: '/action/payment_reversal.php',
    field: 'invoice_payment_id',
  },
  {
    key: 're-invoice',
    label: 'Re-Invoice',
    icon: 'mdi-refresh',
    path: (bn) => `/tools/invoice_regen.php?bn=${bn}`,
  },
  {
    key: 'latest-invoice',
    label: 'Show Latest Invoice',
    icon: 'mdi-file-document-outline',
    path: (bn) => `/v/details.php?bn=${bn}&Referer=1`,
  },
];

export const bpActionListModalStyle = {
  overlay: {
    zIndex: 2200,
    backgroundColor: 'rgba(15, 23, 42, 0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  },
  content: {
    position: 'relative',
    inset: 'auto',
    maxWidth: '720px',
    width: '100%',
    margin: '0',
    padding: '0',
    border: 'none',
    borderRadius: '16px',
    background: 'transparent',
    overflow: 'visible',
  },
};

export const bpActionOverlayModalStyle = {
  overlay: {
    zIndex: 2200,
    backgroundColor: 'rgba(15, 23, 42, 0.55)',
  },
  content: {
    inset: '24px',
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    border: 'none',
    borderRadius: '16px',
    overflow: 'hidden',
    background: '#fff',
  },
};
